import React, { useEffect } from 'react'
import './dashboard.css'
import axios from '../../helpers/axios'
import { useState } from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState'

export default function Dashboard() {
    const [todayInvoiceCount, setTodayInvoiceCount] = useState(0);
    const [todayTotalSales, setTodayTotalSales] = useState(0);

    const getCountTodayInvoices = async () => {
        await axios.get('/invoice/getallivotoday').then(res => {
            setTodayInvoiceCount(res.data.response.count);
        })
    }

    const getTotalAmount = async () => {
        await axios.get('/invoice/getallivotoday').then(res => {
            const invoices = res.data.response

            if (invoices.status === 200) {
                var totalAmount = invoices.data.reduce((total, inv) => total = total + parseFloat(inv.net_price), 0);
                setTodayTotalSales(totalAmount)
            }

        })
    }

    //Import Global States
    const state = useContext(GlobalState);
    const [invoices] = state.invoiceAPI.invoices

    useEffect(() => {
        getCountTodayInvoices();
        getTotalAmount();
    }, [invoices])
    return (
        <div className="overview">
            <div className="title">
                <i className='uil uil-tachometer-fast-alt'></i>
                <span className="text">Dashboard</span>
            </div>

            <div className="boxes">
                <div className="box box1">
                    <i className='uil uil-bill'></i>
                    <span className="text">Today Sales Count</span>
                    <span className="number">{todayInvoiceCount}</span>
                </div>
                <div className="box box2">
                    <i className='uil uil-channel-add'></i>
                    <span className="text">Total Sales</span>
                    <span className="number">Rs. {todayTotalSales}</span>
                </div>
            </div>


            <div className="activity">
                <div className="title">
                    <i className='uil uil-clock-three'></i>
                    <span className="text">Recent Sales</span>
                </div>

                {
                    invoices.count === 0 ? <></>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Invoice No</th>
                                        <th>Customer Name</th>
                                        <th>Qty</th>
                                        <th>Total Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        invoices.count > 0 ? invoices.data.map(inv => (
                                            <tr key={inv.id}>
                                                <td>{inv.invoice_no}</td>
                                                <td>{inv.customer ? inv.customer.first_name + " " + inv.customer.last_name : ''}</td>
                                                <td>{inv.quantity}</td>
                                                <td>Rs {inv.net_price}</td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan="6">Can not found any invoices.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }
            </div>
        </div>
    )
}
